import topic from '../topic';
export const sourAPI = {
  getSours: topic.sourTopic + '/get_sours',
  getSourMtrlsV1: topic.sourTopic + '/get_sour_mtrls_v1',
  getSourById: topic.sourTopic + '/get_sour_by_id',
  addSour: topic.sourTopic + '/add_sour',
  editSour: topic.sourTopic + '/edit_sour',
  deleteSourByIds: topic.sourTopic + '/delete_sour_by_ids',
  judgeSourMtrlNo: topic.sourTopic + '/judge_sour_mtrl_no'
};
